import React, { useState, useEffect } from 'react';
import {
  Button, Row, Col,
  ListGroup, ListGroupItem,
  Modal, ModalHeader, ModalBody, ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';

import api from '../../api';
import apifunctions from '../../api/functions';

import './styles.scss';


const ItemOrderUpdateModal = (props) => {
  const { url, type, nameField, pkField, orderField } = props;

  const [dataset, setDataset] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      const getAndProcess = (reintento = 0) => {
        const successCallback = (response) => {
          let result = [];
          try {
            const sortFn = (a, b) => (a[orderField] - b[orderField]);
            const mapFn = (item) => ({ id: item[pkField], nombre: item[nameField], orden: item[orderField] });
            result = response.data.sort(sortFn).map(mapFn);
          } catch (e) { result = []; }
          setDataset(result);
        }
        const failureCallback = () => {
          if (reintento < 3)
            getAndProcess(reintento + 1);
          else
            showModal(false);
        }
        apifunctions.get(url, null, null, { filters:["DeBaja=False", "paginationEnabled=False"] }, successCallback, failureCallback, failureCallback);
      };
      getAndProcess();
    }
  }, [showModal]);

  const toggle = () => setShowModal(!showModal);

  const saveAndExit = () => {
    const callback = () => {
      setDataset([]);
      setShowModal(false);
    }
    apifunctions.post(api.gestion.updateOrder, null, { dataset: dataset, type: type }, callback, callback, callback);
  }
  const MoveFromTo = (from, to) => {
    if (from && to) {
      let _dataset = [...dataset];
      let _newDataset = [];

      let element = _dataset[from];
      _dataset.splice(from, 1);
      _dataset.splice(to, 0, element);

      _dataset.forEach((item, i) => _newDataset.push(item));
      _newDataset.forEach((item, i) => {
        item.orden = i + 1;
      });

      setDataset(_newDataset);
    }
  };

  const Col_onDragStart = (event, index) => {
    event.dataTransfer.setData("IndexFrom", index);
  };

  const AlphOrder = () => {
    const order = (a,b) => (a.nombre > b.nombre) ? 1 : (b.nombre > a.nombre ? -1 : 0);
    const _dataset = [...dataset].sort(order)
    _dataset.forEach((item, index)=>{
        item.orden = index + 1
    });
    setDataset(_dataset);
  };
  

  const Row_OnDrop = (event) => {
    event.preventDefault();
    let node = event.target;
    while (node && !node.dataset.index) node = node.parentElement;
    if (node && node.dataset.index) {
      const IndexTo = node.dataset.index;
      const IndexFrom = event.dataTransfer.getData("IndexFrom");
      if (IndexTo && IndexFrom) {
        MoveFromTo(IndexFrom, IndexTo);
      }
    }
  };

  const Row_OnDragOver = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <React.Fragment>
      <div>
        <button onClick={toggle} id="buttonSortDestacados" className="icon btn btn-sm h-100 btn-info"><i class="fa fa-bars fa-lg" aria-hidden="true"></i></button>
        <UncontrolledTooltip placement="bottom" target="buttonSortDestacados">
          Definir Orden
        </UncontrolledTooltip>
      </div>

      <Modal isOpen={showModal} toggle={toggle} className={"modal-lg ItemOrderUpdateModal"}>
        <ModalHeader toggle={toggle}>Definir Orden</ModalHeader>
        <ModalBody>
          <div className="p-1 mb-2 border-bottom d-flex justify-content-end">
          <button className="btn btn-primary" onClick={AlphOrder}>Ordenar alfabéticamente</button>
          </div>
          
          <ListGroup>
            {
              dataset.length == 0 &&
              <p>No hay elementos definidos</p>
            }
            {
              <div className="row sortable-conteiner" onDrop={Row_OnDrop} onDragOver={Row_OnDragOver}>
                {
                  dataset.map((item, index) => (
                    <Col
                      xs={3}
                      onDragStart={(event) => Col_onDragStart(event, index)}
                      className="sortable-item cursor-pointer noselect"
                      draggable={true}
                      key={"sortable-item-" + index}
                      data-index={index}
                    >
                      <div className="sortable-item-conteiner">
                        <p className="sortable-item-position-number">{index + 1}</p>
                        <p className="sortable-item-position-text">{item.nombre}</p>
                        <p><span className="sortable-item-icon fa fa-arrows" /></p>
                      </div>
                    </Col>
                  ))
                }
              </div>
            }
          </ListGroup>
        </ModalBody>
        <ModalFooter>
          {
            dataset.length == 0 &&
            <Button color="secondary" onClick={toggle}>Cerrar</Button>
          }
          {
            dataset.length != 0 &&
            <React.Fragment>
              <Button color="success" onClick={() => saveAndExit()}>Guardar</Button>{' '}
              <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </React.Fragment>
          }
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}
export default ItemOrderUpdateModal;


// WEBPACK FOOTER //
// ./src/components/ItemOrderUpdateModal/ItemOrderUpdateModal.js